const blogSelectors = {
    readMoreBtn: document.querySelectorAll('[data-more-btn]')
};

class TemplateBlogArticleJS {
    constructor() {
        this.readMore();
        // Custom code for blog/article page goes here
    }
    readMore(){
        blogSelectors.readMoreBtn.forEach(element => {
          if(element){
            let contentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('ul').scrollHeight;
            let newContentBlockHeight = element.closest('[data-readmorecontainer]').querySelector('ul').offsetHeight;
  
            if (contentBlockHeight == newContentBlockHeight){
              element.closest('[data-readmorecontainer]').querySelector('ul').style.height = 'auto';
              element.classList.add('d-none');
              element.classList.remove('d-inline-flex');
            }
            element.addEventListener('click', (e)=> {
              e.preventDefault();
              let currentTarget = e.target;
              currentTarget.innerHTML = '';
              if(currentTarget.closest('[data-readmorecontainer]').classList.contains('open')){
                setTimeout(function () {
                  currentTarget.closest('[data-readmorecontainer]').querySelector('ul').style.height = '';
                }, 1);
                currentTarget.closest('[data-readmorecontainer]').classList.remove('open');
                currentTarget.innerHTML = 'Show More<i class="icon-arrow-bottom"></i>';
              } else {
                currentTarget.closest('[data-readmorecontainer]').querySelector('ul').style.height = newContentBlockHeight + 'px';
                setTimeout(function () {
                  currentTarget.closest('[data-readmorecontainer]').querySelector('ul').style.height = contentBlockHeight + 'px';
                }, 1);
                setTimeout(function () {
                  currentTarget.closest('[data-readmorecontainer]').classList.add('open');
                }, 300);
                currentTarget.innerHTML = 'Show Less<i class="icon-arrow-top"></i>';
              }
  
            });
          }
        });
      }
}

typeof TemplateBlogArticleJS !== 'undefined' && new TemplateBlogArticleJS();